import "./scroll-indicator.styles.scss";

const ScrollIndicator = () => {
  return <div className="scroll-indicator"></div>;
};

export default ScrollIndicator;
